import styles from "./PositionCard.module.css";
const PositionCard = ({ posDetail }) => {
  const {
    baseTokenSymbol,
    baseTokenImage,
    quoteTokenSymbol,
    quoteTokenImage,
    range,
    baseQty,
    quoteQty,
    lowerPrice,
    upperPrice,
    lpType,
  } = posDetail;

  const leftSide = (
    <div className={styles.left_side}>
      <div className={styles.position_images}>
        <img src={baseTokenImage} alt="" width="30px" />
        <img src={quoteTokenImage} alt="" width="30px" />
      </div>
      <span className={styles.tokens_names}>
        {baseTokenSymbol}/{quoteTokenSymbol}
      </span>
      <span className={styles.position_hash}>0xfa05...db35</span>
      <span className={styles.fee_tier}>0.05%</span>
      <div className={styles.token_amounts}>
        <span>
          {baseQty} {baseTokenSymbol}
        </span>
        <span>
          {quoteQty} {quoteTokenSymbol}
        </span>
      </div>
      <div className={styles.tokenQty}>
        <span>{lowerPrice}</span>
        <span>{upperPrice}</span>
      </div>
    </div>
  );

  const RepositionAndRemoveButtons = (
    <div className={styles.action_buttons_container}>
      <button className={styles.reposition_button}>Reposition</button>
      <button className={styles.remove_button}>Remove</button>
    </div>
  );
  const RemoveButton = (
    <button className={styles.remove_button_only}>Remove</button>
  );
  const rightSide = (
    <div className={styles.right_side}>
      <span className={styles.ambient_title}>
        {lpType === "ambient" ? "Ambient" : "Concentrated"}
      </span>
      {lpType === "ambient" ? RemoveButton : RepositionAndRemoveButtons}
    </div>
  );

  return (
    <div className={styles.position_card}>
      {leftSide}
      {rightSide}
    </div>
  );
};

export default PositionCard;
